<template>
    <div class="">
        <PageBreadcrumb :pagetitle="info.title"/>
        <!-- News -->
        <section class="newssec py-5">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                        <div class="row">
                            <div v-for="article in articles" :key="article.nid" class="col-12 col-md-6 col-lg-4 mb-4">
                                <div class="news-block text-center position-relative">
                                    <div class="news-image shrink-effect position-relative gradient-bt">
                                        <img v-bind:src="article.field_basic_image" alt="" class="img-fluid" />
                                        <div class="news-author text-white bg-primary text-white">
                                            <span><i class="fa fa-user-o"></i> by {{ article.uid }}</span>
                                            <span><i class="fa fa-calendar"></i> {{ article.created }}</span>
                                        </div>
                                    </div>
                                    <div class="news-content">
                                        <h5>{{article.title}}</h5>
                                        <p>{{article.body_1.substring(0,27)+".."}}</p>
                                        <router-link :to="{ name: 'SingleDetail', params: { id: article.current_path }}" class="btn btn-primary">Read More</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <!-- Start SideBarExtras -->
                        <SideBarExtras />
                        <hr>
                        <!-- Start Latest News Sidebar -->
                        <LatestNews />
                        <!-- End Latest News Sidebar -->
                    </div>
                </div>
            </div>
        </section>
        <!-- End News -->
    </div>
</template>

<script>
    import axios from 'axios';
    import LatestNews from "../components/LatestNews";
    import PageBreadcrumb from "../components/PageBreadcrumb";
    import SideBarExtras from "../components/SideBarExtras";

    export default{
        name: 'Beliefs',
        data () {
            return {
                info: { title : "Coming Soon" },
                articles:[]
            }
        },
        components:{
            PageBreadcrumb, LatestNews, SideBarExtras
        },
        mounted() {
            axios
                .get('https://api.fifmi.org.au/api/articles')
                .then(result => {
                    for (var i = 0; i < result.data.length; i++) {
                        if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "article"){
                            result.data[i].current_path = result.data[i].current_path.split('/').pop();
                            this.articles.push(result.data[i]);
                        }
                    }
                });
        },
    }
</script>
